import React, { Fragment } from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    NumberField,
    EmailField,
    SelectField
} from 'react-admin'

import Title from '../Generic/Title'

import { rolesChoices } from './data.js'


export const UsuarioShow = props => {
    const role = localStorage.getItem("role");
    return (
        <Fragment>
            <Title title={"Perfil Usuario"} />
            <Show {...props}>
                <SimpleShowLayout>
                    <NumberField source="id" />
                    <TextField source="username" />
                    <EmailField source="email" />
                    <TextField source="first_name" />
                    <TextField source="last_name" />
                    { role === "coordinado"
                        ? null
                        : (
                            <SelectField
                                source="role"
                                choices={rolesChoices}
                            />
                        )
                    }
                </SimpleShowLayout>
            </Show>
        </Fragment>
    )
};
